import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { CarrierRepository, type getCarrierTractorsParams } from '../infra/CarrierRepository'

export type GetTractorsNumbersDependencies = {
  repository: CarrierRepository
}

export function getTractorsNumbersFactory({ repository }: GetTractorsNumbersDependencies) {
  return async function getCarrierTractorsNumbers({
    carrierUUID,
    query,
    config,
  }: getCarrierTractorsParams) {
    try {
      return await repository.getCarrierTractorsNumbers({ carrierUUID, query, config })
    } catch (error) {
      throw new Error('Failed to get tractors numbers', { cause: error as Error })
    }
  }
}

export function getTractorsNumbers({ carrierUUID, query, config }: getCarrierTractorsParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new CarrierRepository({ httpClient })
  const getTractors = getTractorsNumbersFactory({ repository })

  return getTractors({ carrierUUID, query, config })
}
